import {BaseMuixPageController} from "../../../../components/muix-data-grid/controllers/BaseMuixPageController.ts";
import type {MithraMaterializedApi} from "../../../../services/MithraMaterializedApi.ts";
import type AuthStore from "../../../../authentication/AuthStore.tsx";
import type {BagStore} from "../../../../stores/BagStore.tsx";
import {makeObservable, reaction} from "mobx";
import {BaseMuixApi} from "../../../../components/muix-data-grid/BaseMuixApi.ts";
import {SCTableController} from "./SCTableController.tsx";
import {SCFilterController} from "./SCFilterController.ts";
import type {NestedRelatedDataModel} from "../../../../services/ApiHelpers.ts";

export class SCPageController extends BaseMuixPageController {
    readonly tableController: SCTableController;
    readonly filterController: SCFilterController;
    readonly reviewApi: BaseMuixApi;
    relatedDataFieldsSpec: NestedRelatedDataModel = {
        cat: Array.from(Array(8).keys()).map(i => 'l' + String(i + 1)),
        part: [],
        supplier: [],
        business_unit: ['bu_name'],
    }

    constructor(
        private api: MithraMaterializedApi,
        // Note that declaring this as private would result in this error
        //      Types have separate declarations of a private property
        protected auth: AuthStore,
        protected bagStore: BagStore,
    ) {
        super(auth);
        makeObservable(this, {});
        this.tableController = new SCTableController(auth, bagStore);
        this.filterController = new SCFilterController(this, bagStore);
        this.reviewApi = new BaseMuixApi(this.api, '/m_review/base/muix', this.tableController);
        reaction(() => ([this.bagStore.categorizationColumns]), ([categorizationColumns]) => {
            this.relatedDataFieldsSpec['part'] = categorizationColumns.filter(c =>
                c.table_name === 'data_source_part' && c.in_use
            ).map(c => c.column_name);
            this.relatedDataFieldsSpec['supplier'] = categorizationColumns.filter(c =>
                c.table_name === 'data_source_supplier' && c.in_use
            ).map(c => c.column_name);
        });
    }
}